module.exports = __webpack_public_path__ + "static/img/5.0049681.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/5.jpg
// module id = dVNw
// module chunks = 0